import { FC } from 'react';

const brandLogo = `${process.env.REACT_APP_BASE_URL}/images/logo.png`;
const brandLogoWhite = `${process.env.REACT_APP_BASE_URL}/images/logo-white.png`;

interface ILogoProps {
	width?: number;
	height?: number;
	brandImage?: boolean;
}

const Logo: FC<ILogoProps> = ({ width = 2155, height = 854, brandImage = false }) => {
	return (
		<img
			src={brandImage ? brandLogo : brandLogoWhite}
			alt={`${process.env.REACT_APP_PROJECT_NAME}`}
			height={height}
			width={width}
		/>
	);
};

export default Logo;
